import type { RiskGapModel } from '@ctw/shared/api/fhir/models/risk-gap';
import type { SortOption } from '@ctw/shared/content/resource/resource-table-actions';

export const defaultRiskSort: SortOption<RiskGapModel> = {
  display: 'Name (A to Z)',
  sorts: [{ key: 'title', dir: 'asc' }],
};

export const riskSortOptions: Array<SortOption<RiskGapModel>> = [
  defaultRiskSort,
  {
    display: 'Name (Z to A)',
    sorts: [{ key: 'title', dir: 'desc' }],
  },
];
